import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Phone } from "lucide-react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Prestations } from "@/components/Prestations";
import { Manifesto } from "@/components/Manifesto";
import { Realisations } from "@/components/Realisations";
import { Clients } from "@/components/Clients";
import { Zone } from "@/components/Zone";
import { DevisForm } from "@/components/DevisForm";
import { Footer } from "@/components/Footer";
import { MentionsLegales, PolitiqueConfidentialite } from "@/pages/Legal";
import { LangProvider, useLang } from "@/context/LangContext";
import { COMPANY } from "@/data/site";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

const MobileCallFab = () => {
  const { S } = useLang();
  return (
    <a
      href={COMPANY.phones[0].href}
      data-testid="mobile-call-fab"
      className="sm:hidden fixed bottom-4 inset-x-4 z-40 inline-flex items-center justify-center gap-2.5 rounded-full bg-sky-600 py-4 text-sm font-semibold text-white shadow-2xl shadow-sky-900/50"
    >
      <Phone className="w-4 h-4" />
      {S.fabCallPrefix} {COMPANY.phones[0].label}
    </a>
  );
};

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Prestations />
      <Manifesto />
      <Realisations />
      <Clients />
      <Zone />
      <DevisForm />
    </main>
    <Footer />
    <MobileCallFab />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
